import React from 'react';

import Conversation from 'models/conversation';
import ConversationTopic from 'components/customer/conversation_history/containers/conversation_topic_container';
import ConversationTopicsContainer from 'components/customer/conversation_history/topics/conversation_topics_container';
import CustomerContext from 'components/customer/customer_context';
import { useIsFeatureEnabled } from 'components/contexts/is_feature_enabled';

export function ConversationTopics() {
  const isFeatureEnabled = useIsFeatureEnabled();
  return (
    <CustomerContext.Consumer>
      {({ customerId, latestConversationId, latestConversationStatus }) => {
        if (!latestConversationId || latestConversationStatus === Conversation.Status.CLOSED) {
          return null;
        }

        return isFeatureEnabled('conversationTopicsFix') ? (
          <ConversationTopicsContainer conversationId={latestConversationId} customerId={customerId} />
        ) : (
          <ConversationTopic conversationId={latestConversationId} customerId={customerId} />
        );
      }}
    </CustomerContext.Consumer>
  );
}

export default ConversationTopics;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_topics.jsx